import React, { Children, useEffect, useRef, useState } from 'react'
import Box from '@mui/material/Box'
import Popper from '@mui/material/Popper'
import { Typography } from '@mui/material'

const ACPopper = ({
  customButton,
  buttonIcon = 'more_horiz-rounded',
  linePlacement,
  children,
  popperId = 'AdxPopper',
  sx,
  childBoxSx,
  closeOnClick = 'all',
  placeholder,
  placeholderColor,
  startIcon,
  ...rest
}) => {
  const refButton = useRef('ref')
  const refPopper = useRef('ref')
  const arrayChidren = Children.toArray(children)
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const open = Boolean(anchorEl)
  const id = open ? popperId : undefined

  useEffect((e) => {
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (
        open &&
        refPopper.current &&
        !refPopper.current.contains(e.target) &&
        refButton.current &&
        !refButton.current.contains(e.target)
      ) {
        setAnchorEl(false)
      }
    }

    document.addEventListener('mousedown', checkIfClickedOutside)

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside)
    }
  })

  return (
    <>
      <Box
        onClick={handleClick}
        display="flex"
        alignItems="center"
        justifyContent="start"
        ref={refButton}
        sx={{ cursor: 'pointer', gap: 1, ...sx }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>{startIcon}</Box>
        <Typography color={placeholderColor}>{placeholder}</Typography>
      </Box>
      {arrayChidren.length > 0 ? (
        <Popper id={id} open={open} anchorEl={anchorEl} style={{ zIndex: 10 }} {...rest}>
          <Box
            ref={refPopper}
            sx={{
              border: '1px solid',
              borderColor: 'gray-line.main',
              borderRadius: 2,
              bgcolor: 'white.main',
            }}
          >
            {arrayChidren.map((item, index1) => (
              <React.Fragment key={index1}>
                {linePlacement
                  ? linePlacement.map((item, index2) =>
                      item === index1 ? (
                        <Box
                          key={index2}
                          borderBottom="1px solid"
                          sx={{ borderColor: 'gray-line.main' }}
                        />
                      ) : null
                    )
                  : null}
                <Box
                  key={index1}
                  margin={0.5}
                  paddingY={1}
                  paddingX={1.5}
                  borderRadius={1}
                  onClick={
                    closeOnClick === 'all'
                      ? () => setAnchorEl(false)
                      : closeOnClick === 'none'
                      ? null
                      : (e) => {
                          if (e.target.type === closeOnClick) {
                            setAnchorEl(false)
                          }
                        }
                  }
                  sx={{
                    cursor: 'pointer',
                    color: 'dark-text.main',
                    '&:hover': {
                      bgcolor: !item.type.name ? 'gray-background.main' : null,
                    },
                    ...childBoxSx,
                  }}
                >
                  {item}
                </Box>
              </React.Fragment>
            ))}
          </Box>
        </Popper>
      ) : null}
    </>
  )
}

export default ACPopper
